export default class SuuntoService {
  constructor(dao, logger) {
    this.dao = dao;
    this.logger = logger;
  }

  // @param member is the Vuex store member
  // @param followees is the Vuex store followees
  async requestActivitiesRefresh(member, followees) {
    try {
      if (member) {
        const payload = this.createActivitiesRefreshPayload(member, followees);
        if (payload.params.members.length > 0) {
          await this.dao.requestSuuntoActivityRefresh(payload);
        }
      }
    } catch (err) {
      this.logger.capture(err);
    }
  }

  // @param mamber is the Vuex store member
  // @param followees is the Vuex store followees
  createActivitiesRefreshPayload(member, followees) {
    const payload = {
      action: 'load_activities_for_members',
      params: {
        members: [],
      },
    };
    const allMembers = followees.concat([member]);
    allMembers.forEach((element) => {
      try {
        if (element.memberId !== null) {
          payload.params.members.push({
            member_id: element.memberId,
            use_most_recent_activity_date: true,
          });
        } else {
          this.logger.capture(`Missing memberId for member: ${element}`);
        }
      } catch (err) {
        this.logger.capture(err);
      }
    });
    return payload;
  }
}
